<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        (exitViewAs)="this.onExitViewAs($event)"
                                        [roleName]="this.consultantRoleName"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <br>
      <app-st-header-title [inputVal]="'Your Wishlist'"></app-st-header-title>
      <br>
      <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
        <app-st-span><b>Please validate the following: </b></app-st-span>
        <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showPageSuccessMessages" class="container st-form text-success" #goUp>
        <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <div class="container st-form">
        <div>
          <div *ngIf="create">
            <app-st-span [inputVal]="'Feedback Type'"></app-st-span>
            <br>
            <app-st-select *ngIf="create" [idVal]="'feedback-type-dropdown-list-id'" [label]="''" [idKey]="'feedbackTypeId'" [displayKey]="'feedbackTypeDisplayName'" [valueKey]="'feedbackTypeName'" [inputArray]="this.feedbackTypesList"></app-st-select>
          </div>
          <div *ngIf="!create">
            <app-st-input-text [idVal]="'feedback-type-txt-id'"
                             [label]="'Feedback Type'" [inputVal]="savedFeedbackType" [requiredVal]="true" [disabled]="!create"></app-st-input-text>
          </div>
          <br>
          <div class="row pt-2">
            <div class="col">
              <app-st-input-text [idVal]="'feedback-title-txt-id'"
                                 [label]="'Title'" [inputVal]="savedFeedbackTitle" [requiredVal]="true" [disabled]="!create"
                                 [maxLength]="60"
              ></app-st-input-text>
            </div>
          </div>
          <br>
          <div class="row pt-2">
            <div class="col">
              <app-st-textarea [idVal]="'feedback-textarea-txt-id'"
                                 [label]="'Your Feedback'" [inputVal]="savedFeedbackTxt" [rows]="10" [cols]="50"
                               [requiredVal]="true" [disabled]="!create"></app-st-textarea>
            </div>
          </div>

        </div>
        <br>
        <app-st-button-back-to-top></app-st-button-back-to-top>
        <br>
        <div *ngIf="create" class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                         [idVal]="'submit-button-id'" [label]="'Submit'" [primary]="true"
                         (click)="this.onSubmit()"></app-st-button>
          <app-st-button-cancel [idVal]="'cancel-button-id'" [label]="'Cancel'" [primary]="false"
                         (click)="this.onCancel()"></app-st-button-cancel>
        </div>
      </div>
    </div>
  </div>
</div>
